import React from 'react';
export function Logo({
  inverted = false
}: {
  inverted?: boolean;
}) {
  return <span className={`inline-flex flex-col items-center px-3 py-1.5 leading-none ${inverted ? 'bg-white text-ink' : 'bg-ink text-white'}`} data-id="element-88" data-mp="8stejw0wh9k3">
      <span className="font-serif text-[15px] font-semibold tracking-wide whitespace-nowrap" data-id="element-89" data-mp="3q7i19my9zv4g">COMME UN CHARME</span>
      <span className="mt-1 flex items-center gap-1.5 text-[8px] tracking-[0.3em]" data-id="element-90" data-mp="3v6bdzd5qni3k">
        <span className={`h-px w-4 ${inverted ? 'bg-ink' : 'bg-white'}`} data-id="element-91" data-mp="mqrq6tnu6rvw" />
        PARIS
        <span className={`h-px w-4 ${inverted ? 'bg-ink' : 'bg-white'}`} data-id="element-92" data-mp="rr606h900bwk" />
      </span>
    </span>;
}